'use strict';
var novicell = novicell || {};

novicell.loadMoreVideos = novicell.loadMoreVideos || function () {

    function init() {
        let post_wrapper = document.querySelectorAll('.js-load-more-wrapper');

        if ( post_wrapper ) {
            load_more(post_wrapper);
        }

    }

    function load_more(lists) {
        let action = 'load_more_posts';

        lists.forEach(list => {
            let posts_list      = list.querySelector('.js-load-more-list'),
                load_more_btn   = list.querySelector('.js-load-more-btn'),
                paged           = 1;

            if ( load_more_btn ) {
                
                load_more_btn.addEventListener('click', function(e) {
                    e.stopPropagation;

                    var paged = nh_ajax_object.current_page;

                    paged++;

                    console.log(paged);

                    let btn             = e.target,
                        post_type       = btn.getAttribute('data-post-type'),
                        posts_per_page  = btn.getAttribute('data-posts-per-page'),
                        video_type      = btn.getAttribute('data-video-category'),
                        query           = nh_ajax_object.posts,
                        page            = nh_ajax_object.current_page,
                        filtered        = nh_ajax_object.filtered,
                        category        = nh_ajax_object.category;

                        if ( nh_ajax_object.max_page == 0 ) {
                            var max_pages = btn.getAttribute('data-max-pages');
                        } else {
                            var max_pages = nh_ajax_object.max_page;
                        }

                    btn.innerHTML = 'Henter...';

                    loadMorePostsRequest(action, post_type, max_pages, paged, posts_per_page, video_type, query, category, filtered, page, btn, posts_list);
                });
            }
        });
    }

    function loadMorePostsRequest(action, post_type, max_pages, paged, posts_per_page, video_type, query, category, filtered, page, btn, posts_list) {
        // https://getbutterfly.com/how-to-replace-jquery-ajax-with-vanilla-javascript-in-wordpress/
        var request = new XMLHttpRequest(),
            method  = 'POST',
            url     = ajaxurl;

        request.open(method, url, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');

        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // If successful
                let posts       = posts_list.innerHTML,
                    new_posts   = this.response;

                nh_ajax_object.current_page++;

                posts += new_posts;

                posts_list.innerHTML = posts;

                novicell.lazyLoader.lazy_load(posts_list);

                if ( paged < max_pages ) {
                    btn.innerHTML = 'Se flere';
                } else {
                    btn.style.display = 'none';
                }
            } else {
                // If fail
                console.log(this.response);
            }
        };

        request.onerror = function() {
            alert("Request failed");
        };

        request.send(   'action=' + action + 
                        '&post_type=' + post_type + 
                        '&paged=' + paged + 
                        '&posts_per_page=' + posts_per_page  + 
                        '&video_type=' + video_type + 
                        '&query=' + query + 
                        '&page=' + page +
                        '&category=' + category +
                        '&filtered=' + filtered
                    );
    }

    return {
        init : init
    };

}();